import React from "react"

import { ProductPositionConfigurationButtons } from "./ProductPositionConfigurationButtons"
import { ProductPositionDisplayPositionInput } from "./inputs/ProductPositionDisplayPositionInput"
import { ProductPositionIsAlternativeInput } from "./inputs/ProductPositionIsAlternativeInput"
import { ProductPositionPositionInput } from "./inputs/ProductPositionPositionInput"
import { ProductPositionPriceGroupInput } from "./inputs/ProductPositionPriceGroupInput"
import { ProductPositionPriceInput } from "./inputs/ProductPositionPriceInput"
import { ProductPositionProjectInput } from "./inputs/ProductPositionProjectInput"
import { ProductPositionQuantityInput } from "./inputs/ProductPositionQuantityInput"
import { ProductPositionRoomInput } from "./inputs/ProductPositionRoomInput"
import { ProductPositionSpecialPriceGroupInput } from "./inputs/ProductPositionSpecialPriceGroupInput"
import { ProductPositionTotalPrice } from "./inputs/ProductPositionTotalPrice"
import { ProductPositionVariantKeyInput } from "./inputs/ProductPositionVariantKeyInput"

export const ProductPositionFormGeneralTab = React.memo(() => {
  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--general">
      <ProductPositionProjectInput />
      <div className="product-position-form__configuration">
        <ProductPositionVariantKeyInput />
        <ProductPositionConfigurationButtons />
      </div>
      <ProductPositionRoomInput />
      <div className="product-position-form__field-grid">
        <ProductPositionPositionInput />
        <ProductPositionQuantityInput />
        <ProductPositionDisplayPositionInput />
        <ProductPositionIsAlternativeInput />
        <ProductPositionPriceInput />
        <ProductPositionPriceGroupInput />
        <ProductPositionSpecialPriceGroupInput />
        <ProductPositionTotalPrice />
      </div>
    </div>
  )
})
